import React, { useState, useEffect } from "react";
import Icon from "../../../common/components/Icon";
import Modal from "../../../common/components/MessageModal";

import { getUserInfo } from "../../../api/usercall";
import { halykPaymentGenerate } from "../../../api/halykPaymentGenerate";
import infoIcon from '../../../assets/icons/info.svg';
import { t } from "i18next";
import monitoringService from "../../../services/monitoringService";

function WalletTopUp({ setActiveTab }) {
    const [amount, setAmount] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [userInfo, setUserInfo] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        const fetchUserInfo = async () => {
            try {
                const data = await getUserInfo();
                setUserInfo(data.user);
            } catch (err) {
                console.error("Failed to fetch user info:", err);
            }
        };
        fetchUserInfo();
    }, []);

    const handleAmountClick = (value) => setAmount(value.toString());

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!amount || parseFloat(amount) <= 0) {
            setModalMessage("Ошибка: Введите корректную сумму пополнения.");
            setShowModal(true);
            return;
        }
        if (!userInfo?.id) {
            setModalMessage("Ошибка: Не удалось получить данные пользователя.");
            setShowModal(true);
            return;
        }

        setIsSubmitting(true);
        try {
            const data = await halykPaymentGenerate(parseFloat(amount), "KZT");
            monitoringService.trackBalanceTopUp(parseFloat(amount), "KZT", true, null).catch(() => {});
            window.location.href = data.invoice_url;
        } catch (error) {
            const errorMsg = error.message || "Ошибка при пополнении.";
            setModalMessage(errorMsg);
            setShowModal(true);
            monitoringService.trackBalanceTopUp(parseFloat(amount), "KZT", false, errorMsg).catch(() => {});
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="w-full">
            <Icon src="backicon" onClick={() => setActiveTab(null)} className="block md:hidden fixed left-5 top-[23px] cursor-pointer z-[102]" />

            <div className="bg-white rounded-2xl p-6 max-w-lg">
                {/* Balance card */}
                {userInfo && (
                    <div className="bg-[#147F26]/5 rounded-xl p-4 mb-6 flex items-center justify-between">
                        <div>
                            <p className="text-xs text-gray-500 mb-1">{t('yourBalance')}</p>
                            <p className="text-2xl font-bold text-[#147F26]">
                                {userInfo.balance || 0} <span className="text-sm font-normal">{t('units')}</span>
                            </p>
                        </div>
                        <div className="w-12 h-12 bg-[#147F26]/10 rounded-full flex items-center justify-center">
                            <img src={infoIcon} alt="info" className="w-5 h-5" />
                        </div>
                    </div>
                )}

                <form onSubmit={handleSubmit} className="flex flex-col gap-5">
                    {/* Amount input */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            {t('sum_top_up')}
                        </label>
                        <input
                            type="number"
                            value={amount && amount !== 'None' && amount !== 'null' ? amount : ''}
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder={t('enter_sum')}
                            className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-gray-50 text-base focus:outline-none focus:border-[#147F26] focus:bg-white transition-colors"
                            min="1"
                        />
                    </div>

                    {/* Quick amount buttons */}
                    <div className="grid grid-cols-4 gap-2">
                        {[1000, 5000, 20000, 100000].map((value) => (
                            <button
                                key={value}
                                type="button"
                                onClick={() => handleAmountClick(value)}
                                className={`py-2 rounded-xl text-sm font-medium border transition-all
                                    ${amount === value.toString()
                                        ? 'bg-[#147F26] text-white border-[#147F26]'
                                        : 'border-[#147F26] text-[#147F26] hover:bg-[#0f5f1a]/50 hover:text-white'
                                    }`}
                            >
                                {value.toLocaleString()} ₸
                            </button>
                        ))}
                    </div>

                    {/* Divider */}
                    <div className="border-t border-gray-100" />

                    {/* Payment method */}
                    <div>
                        <p className="text-sm font-medium text-gray-700 mb-3">{t('service_for_replenishment')}</p>
                        <div className="flex items-center gap-3 p-3 rounded-xl border border-gray-200 bg-gray-50">
                            <Icon src="mastercard" />
                            <span className="text-sm text-gray-600">{t('banks_card')}</span>
                        </div>
                    </div>

                    {/* Submit */}
                    <button
                        type="submit"
                        disabled={isSubmitting || !amount}
                        className="w-full py-3.5 bg-[#147F26] hover:bg-[#0f5f1a] disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold rounded-xl transition-colors"
                    >
                        {isSubmitting ? t('loading') || '...' : t('replenishWallet')}
                    </button>

                    {/* Info */}
                    <p className="text-xs text-gray-400 text-center">{t('rule_unit')}</p>
                </form>
            </div>

            <Modal show={showModal} message={modalMessage} onClose={() => setShowModal(false)} />
        </div>
    );
}

export default WalletTopUp;
